import React, { FunctionComponent, ReactNode, useMemo, useReducer } from "react";
import CartContext from "@Contexts/CartContext";
import { cartReducer, CartState, InitialCartState } from "@States/cart";
import { Configuration } from "@Types/cart";

interface Props {
  children: ReactNode;
  configuration: Configuration;
  initialState: InitialCartState;
}

const CartStateProvider: FunctionComponent<Props> = ({ initialState, children, configuration }) => {
  const completeInitialState: CartState = {
    track: () => Promise.resolve(),
    ui: {
      disabled: false,
      draftsNumber: 0,
      step: "checkout",
      steps: ["checkout", "address", "overview"],
    },
    ...initialState,
  };

  const [state, dispatch] = useReducer(cartReducer, completeInitialState);

  const context = useMemo(
    () => ({
      ...state,
      configuration,
      dispatch,
    }),
    [configuration, state, dispatch]
  );

  return <CartContext.Provider value={context}>{children}</CartContext.Provider>;
};

export default CartStateProvider;
